<template>
  <v-dialog v-model="dialogReceipt" persistent max-width="80%">
    <div class="receipt">
      <v-card
        class="ma-0 py-2 px-4"
        style="background: #F5F5F5; color: #AC0606;"
        outlined
        tile
      >
        <h3 style="text-transform: uppercase">
          {{
            transactionNumber
              ? `Phiếu thu ${transactionNumber}`
              : "Tạo phiếu thu"
          }}
        </h3>
      </v-card>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card
          class="ma-0 mt-4 py-2 px-4"
          style="background: #F5F5F5;"
          outlined
          tile
        >
          <v-row>
            <v-col cols="12" md="6">
              <!-- Mã đơn hàng -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Mã đơn hàng
                </div>
                <div class="info-payment-price text-left">
                  {{ orderId }}
                </div>
              </div>
              <!-- Tên khách hàng -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Tên khách hàng
                </div>
                <div class="info-payment-price text-left">
                  <span v-if="transactionNumber">
                    {{ _.get(detailReceipt.order, "receiver.name", null) }}
                  </span>
                  <span v-else>
                    {{ _.get(detailOrder.receiver, "name", null) }}
                  </span>
                </div>
              </div>
              <!-- Số điện thoại -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Số điện thoại
                </div>
                <div class="info-payment-price text-left">
                  <span v-if="transactionNumber">
                    {{ _.get(detailReceipt.order, "receiver.mobile", null) }}
                  </span>
                  <span v-else>
                    {{ _.get(detailOrder.receiver, "mobile", null) }}
                  </span>
                </div>
              </div>
              <!-- Email -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Email
                </div>
                <div class="info-payment-price text-left">
                  <span v-if="transactionNumber">
                    {{ _.get(detailReceipt.order, "receiver.email", null) }}
                  </span>
                  <span v-else>
                    {{ _.get(detailOrder.receiver, "email", null) }}
                  </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <!-- Hình thức thanh toán -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Hình thức thanh toán
                </div>
                <div style="width: 100%;">
                  <v-autocomplete
                    hide-details=""
                    :items="listPayment"
                    item-text="name"
                    item-value="value"
                    v-model="payment"
                    placeholder="Chọn hình thức thanh toán"
                    solo
                    dense
                    readonly
                  >
                  </v-autocomplete>
                </div>
              </div>
              <!-- Loại hình thanh toán -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Loại hình thanh toán
                </div>
                <div
                  class="info-payment-price text-left px-3"
                  style="background: #fff; border: none;"
                >
                  {{ paymentType }}
                </div>
              </div>
              <!-- Phụ phí -->
              <div class="d-flex align-center justify-space-between mt-2">
                <div class="title-field">
                  Phụ phí (VNĐ)
                </div>
                <div style="width: 100%;">
                  <v-currency-field
                    :valueAsInteger="true"
                    :allowNegative="true"
                    :defaultValue="0"
                    :min="0"
                    solo
                    dense
                    hide-details=""
                    v-model="surcharge"
                    readonly
                  />
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Số tiền -->
          <div class="mt-10 payment">
            <div class="d-flex align-center justify-space-between border">
              <div class="lable">Số tiền thanh toán (VNĐ)</div>
              <div style="width: 100%;">
                <v-currency-field
                  :valueAsInteger="true"
                  :allowNegative="true"
                  :defaultValue="0"
                  :min="0"
                  solo
                  dense
                  hide-details=""
                  v-model="paidAmount"
                  readonly
                />
              </div>
            </div>
            <div
              class="d-flex align-center justify-space-between border bt-none"
            >
              <div class="lable">Viết bằng chữ</div>
              <div style="width: 100%;">
                <v-text-field
                  solo
                  dense
                  hide-details=""
                  v-model="paidAmountText"
                  readonly
                ></v-text-field>
              </div>
            </div>
          </div>

          <!-- Ghi chú -->
          <div class="mt-10">
            <div style="color: #000; font-weight: 600">
              Ghi chú
            </div>
            <v-textarea
              auto-grow
              variant="outlined"
              rows="4"
              row-height="25"
              outlined
              class="note mt-1"
              v-model="note"
              placeholder="Nhập ghi chú"
              :disabled="!isEdit && !!transactionNumber"
              :rules="[
                (v) => !v || v.length < 255 || 'Ghi chú không quá 255 ký tự',
              ]"
            ></v-textarea>
          </div>

          <!-- btn -->
          <div class="mt-10 mb-5 d-flex align-end justify-space-between">
            <div>
              <div
                v-if="transactionNumber"
                class="d-flex align-center"
                style="color: #000;"
              >
                <i class="mr-4">
                  Ngày tạo:
                  {{ `${formatHour(createdAt)} ${formatDate(createdAt)}` }}
                </i>
                <i>
                  Người tạo:
                  {{ _.get(detailReceipt.createdBy, "fullName", null) }}
                </i>
              </div>
            </div>
            <div>
              <div v-if="!transactionNumber">
                <v-btn
                  min-width="70"
                  class="mr-2"
                  small
                  color="##949494"
                  @click="closePopup()"
                >
                  Huỷ
                </v-btn>
                <v-btn
                  min-width="70"
                  class="mr-0"
                  small
                  color="#AC0606"
                  @click="saveReceipt()"
                  :disabled="isCallingApi"
                >
                  Lưu
                </v-btn>
              </div>
              <div v-else>
                <div v-if="!isEdit">
                  <v-btn
                    min-width="70"
                    class="mr-2"
                    small
                    color="##949494"
                    @click="closePopup()"
                  >
                    Đóng
                  </v-btn>
                  <span
                    v-if="
                      status == 6 &&
                        _.get(detailReceipt, 'order.status', 3) != 3
                    "
                  >
                    <!-- Chỉ hiện thị khi 'hình thức thanh toán' là 'chuyển khoản' -->
                    <v-btn
                      v-if="payment == BANK_TRANSFER"
                      min-width="70"
                      class="mr-2"
                      small
                      color="#F49D0B"
                      @click="confirmReceipt()"
                    >
                      Xác nhận
                    </v-btn>
                    <v-btn
                      min-width="70"
                      class="mr-0"
                      small
                      color="#AC0606"
                      @click="isEdit = true"
                    >
                      Chỉnh sửa
                    </v-btn>
                  </span>
                </div>
                <div v-else>
                  <v-btn
                    min-width="70"
                    class="mr-2"
                    small
                    color="##949494"
                    @click="
                      {
                        (isEdit = false), getDetailReceipt();
                      }
                    "
                  >
                    Huỷ
                  </v-btn>
                  <v-btn
                    min-width="70"
                    class="mr-2"
                    small
                    color="#1890FF"
                    @click="updateReceipt()"
                  >
                    Lưu
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-form>
    </div>
  </v-dialog>
</template>

<script>
import VNnum2words from "vn-num2words";
import OrderRepository from "@/pages/order-management/services/OrderRepository.js";

export default {
  name: "VhPosFrontendReceipts",
  props: {
    dialogReceipt: {
      type: Boolean,
      default: true,
    },
    dataDialogReceipt: {
      type: Object,
    },
  },

  data() {
    return {
      valid: false,
      isCallingApi: false,
      orderId: null,
      transactionNumber: null,
      isEdit: false,
      payment: "Transfer",
      listPayment: [],
      paymentType: "Thanh toán toàn phần",
      surcharge: 0,
      paidAmount: 0,
      paidAmountText: null,
      note: null,
      detailOrder: {},
      detailReceipt: {},
      createdAt: null,
      status: null,
      BANK_TRANSFER: 'Transfer',
    };
  },

  created() {
    this.getFilter();
    this.orderId = _.get(this.dataDialogReceipt, "orderId", null);
    this.transactionNumber = _.get(
      this.dataDialogReceipt,
      "transactionNumber",
      null
    );
    if (this.transactionNumber) {
      this.getDetailReceipt();
    } else {
      this.getDetailOrder();
    }
  },

  methods: {
    // Chi tiết Phiếu thu
    async getDetailReceipt() {
      const res = await OrderRepository.detailReceipt(this.transactionNumber);
      if (res.success) {
        this.detailReceipt = res.data;
        this.note = res.data.description;
        this.paidAmount = res.data.amount;
        this.paidAmountText = this.numberToText(res.data.amount);
        this.payment = res.data.paymentName;
        this.paymentType = res.data.paymentKind;
        this.createdAt = res.data.createdAt;
        this.status = res.data.status;
      }
    },

    // Lấy chi tiết đơn hàng
    async getDetailOrder() {
      const params = {};
      const res = await OrderRepository.detailOrder(this.orderId, params);
      if (res.success) {
        this.detailOrder = res.data;
        if (!this.transactionNumber) {
          this.paidAmount = res.data.totalAmount;
          this.paidAmountText = this.numberToText(res.data.totalAmount);
        }
      }
    },

    // convert Number to text
    numberToText(number) {
      let string = VNnum2words(number);
      string = string.charAt(0).toUpperCase() + string.slice(1);
      return _.trim(string) + " đồng";
    },

    async getFilter() {
      const res = await OrderRepository.listFilter();
      if (res.success) {
        this.listPayment = res.data.paymentNameOptions;
      }
    },

    // Lưu phiếu thu
    async saveReceipt() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.isCallingApi = true;
        const data = {
          amount: this.detailOrder.totalAmount,
          currency: "VND",
          paymentReference: this.orderId,
          ts: Date.now(),
          paymentMethod: this.payment,
          // surcharge: this.surcharge,
          description: this.note,
        };
        const res = await OrderRepository.createReceipt(data);
        this.isCallingApi = false;
        if (res.success) {
          this.$swal({
            icon: "success",
            title: "Thành công",
            text: "Thao tác thành công!",
          }).then(() => {
            this.$emit("update-success");
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Lỗi",
            text: res.message,
          });
        }
      }
    },

    // Xác nhận phiếu thu
    async confirmReceipt() {
      const data = {
        status: 3,
      };
      const res = await OrderRepository.confirmReceipt(
        this.transactionNumber,
        data
      );
      if (res.success) {
        this.$swal({
          icon: "success",
          title: "Thành công",
          text: "Thao tác thành công!",
        }).then(() => {
          // this.getDetailOrder();
          this.getDetailReceipt();
          this.$emit("re-check-order", {
            transactionNumber: this.transactionNumber,
          });
        });
      } else {
        this.$swal({
          icon: "error",
          title: "Lỗi",
          text: res.message,
        });
      }
    },

    // Chỉnh sửa phiếu thu
    async updateReceipt() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        const data = {
          description: this.note,
        };
        const res = await OrderRepository.updateReceipt(
          this.transactionNumber,
          data
        );
        if (res.success) {
          this.$swal({
            icon: "success",
            title: "Thành công",
            text: "Thao tác thành công!",
          }).then(() => {
            this.isEdit = false;
            this.$emit("update-success");
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Lỗi",
            text: res.message,
          });
        }
      }
    },

    // đóng popup
    closePopup() {
      this.$emit("close-popup");
    },

    // Quay lại màn danh sách
    backToList() {
      this.$router.push({
        name: "PaymentHub",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.receipt {
  background: #fff;
  padding: 20px;
}
.title-field {
  min-width: 160px;
  color: #000;
  font-weight: 700;
}

.info-payment-price {
  height: 38px;
  line-height: 28px;
  background: #d9d9d9;
  border: 1px solid #00000033;
  border-radius: 3px;
  width: 100%;
  text-align: right;
  padding: 5px 4px;
}
.payment {
  .lable {
    height: 40px;
    line-height: 40px;
    width: 250px;
    background: #d9d9d980;
    padding-left: 10px;
    font-weight: bold;
  }
  .border {
    border: 1px solid #b7b7b7;
  }
  .bt-none {
    border-top: none;
  }
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  -webkit-box-shadow: none;
  box-shadow: none !important;
}
</style>
